import type { TRootState } from 'store';
import type { ITableSelector } from 'interfaces/Table/selector.interface';
import { createTableSelectorSlice } from 'redux/table/helper/createTableSelector.slice';
import {
  itemsPerPageDefault,
  currentPageDefault,
  createdAtSortingDefault,
} from 'redux/table/consts/tableDefaults.consts';

export const missionGalleryImagesSlice = createTableSelectorSlice(
  'paginatedMissionGalleryImages',
  currentPageDefault,
  itemsPerPageDefault,
  createdAtSortingDefault
);

const { actions, reducer } = missionGalleryImagesSlice;

export const {
  setPagination,
  setNextPage,
  setSorting,
  setItemsPerPage,
  setFilters,
  setInitialFiltersSet,
  setMenuColumnList,
} = actions;

export const paginatedMissionGalleryImagesSelector = (
  state: TRootState
): ITableSelector => state.tableMissionGalleryImages;

export default reducer;
